import wx from "weixin-js-sdk";
export function useWxSDK() {
  function initConfig(res, dataList) {
    wx.config({
      debug: process.env.VUE_APP_WEI_XIN_DEBUG === "enable",
      appId: res.appId,
      timestamp: res.timestamp,
      nonceStr: res.nonceStr,
      signature: res.signature,
      jsApiList: [
        "onMenuShareTimeline",
        "onMenuShareAppMessage",
        "onMenuShareWeibo",
        "onMenuShareQQ",
        "onMenuShareQZone",
      ],
      openTagList: [],
    });
    wx.ready(() => {
      console.log("设置微信分享");
      /** 设置微信分享 */
      wx.onMenuShareTimeline({
        title: dataList.title, // 分享标题
        desc: dataList.desc,
        link: sessionStorage.getItem("linkUrl"), // 分享链接，可以不是当前页面，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: dataList.imgUrl,
        success: function () {},
        cancel: function () {},
      });
      wx.onMenuShareAppMessage({
        title: dataList.title, // 分享标题
        desc: dataList.desc,
        link: sessionStorage.getItem("linkUrl"), // 分享链接，可以不是当前页面，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: dataList.imgUrl,
        success: function () {
          // 用户确认分享后执行的回调函数
        },
        cancel: function () {
          // 用户取消分享后执行的回调函数
        },
      });
      wx.onMenuShareWeibo({
        title: dataList.title, // 分享标题
        desc: dataList.desc,
        link: sessionStorage.getItem("linkUrl"), // 分享链接，可以不是当前页面，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: dataList.imgUrl,
        success: function () {
          // 用户确认分享后执行的回调函数
        },
        cancel: function () {
          // 用户取消分享后执行的回调函数
        },
      });
      wx.onMenuShareQQ({
        title: dataList.title, // 分享标题
        desc: dataList.desc,
        link: sessionStorage.getItem("linkUrl"), // 分享链接，可以不是当前页面，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: dataList.imgUrl,
        success: function () {
          // 用户确认分享后执行的回调函数
        },
        cancel: function () {
          // 用户取消分享后执行的回调函数
        },
      });
      wx.onMenuShareQZone({
        title: dataList.title, // 分享标题
        desc: dataList.desc,
        link: sessionStorage.getItem("linkUrl"), // 分享链接，可以不是当前页面，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: dataList.imgUrl,
        success: function () {
          // 用户确认分享后执行的回调函数
        },
        cancel: function () {
          // 用户取消分享后执行的回调函数
        },
      });
    });
  }
  return {
    initConfig,
  };
}
